<template>
  <div class="w-full py-3 md:flex">
    <section class="w-full">
      <section class="hidden md:grid">
        <div
          class="shadow relative"
          @mouseover="!isAdminView ? isBannerOptionsOpen = true : ''"
          @mouseleave="!isAdminView ? isBannerOptionsOpen = false : ''"
        >
          <img
            class="object-cover w-full rounded-lg shadow h-56"
            :src="baseUrlSrc(profile && profile.banner_url)"
            alt=""
            @error="defaultImage"
          />
          <div class="absolute top-0 right-0 mr-2 mt-2">
            <div class="flex items-center">
              <div v-if="isBannerOptionsOpen">
                <button
                  type="button"
                  class="text-black shadow-lg bg-gray-100 rounded-full p-2"
                  v-if="profile && profile.banner_url"
                  @click.prevent="handleProfileBannerRemove"
                >
                  <Trash />
                </button>
                <button
                  type="button"
                  class="text-black shadow-lg bg-gray-100 rounded-full p-2"
                  @click.prevent="isBannerModalOpen = !isBannerModalOpen"
                >
                  <Pencil />
                </button>
              </div>

              <!-- banner modal -->
              <Modal v-model="isBannerModalOpen" :title="'Edit Banner Image'">
                <div class="mb-2">
                  <div v-if="thumbnailImagePreview">
                    <Cropper
                      ref="cropper"
                      class="twitter-cropper"
                      background-class="twitter-cropper__background"
                      foreground-class="twitter-cropper__foreground"
                      image-restriction="stencil"
                      default-boundaries="fill"
                      :stencil-size="stencilSize"
                      :stencil-props="{
                        handlers: {},
                        movable: false,
                        scalable: false,
                        aspectRatio: 16 / 4,
                        previewClass: 'twitter-cropper__stencil',
                      }"
                      :transitions="false"
                      :canvas="true"
                      :debounce="false"
                      :default-size="defaultSize"
                      :min-width="250"
                      :min-height="250"
                      :src="thumbnailImagePreview"
                      @change="onChange"
                    />
                    <Navigation
                      :zoom="zoom"
                      @change="onZoom"
                      @zoomInBtn="zoomIn"
                      @zoomOutBtn="zoomOut"
                    />
                  </div>
                  <div
                    v-else
                    class="flex justify-center p-4 bg-gray-300 shadow"
                  >
                    <div v-if="profile && profile.banner_url">
                      <img
                        :src="baseUrlSrc(profile && profile.banner_url)"
                        alt=""
                        class="object-cover rounded"
                        @error="defaultImage"
                      />
                    </div>
                  </div>
                  <span class="text-gray-700">Upload File</span>
                  <input
                    type="file"
                    class="form-input mt-1 block w-full"
                    @change="handleBannerImageChange"
                  />
                </div>
                <div class="mb-2 float-right">
                  <button
                    class="ring-green-dark ring-1 rounded py-1 px-4 mr-2 text-green-dark"
                    @click="propfileBannerUploadToggler"
                  >
                    Cancel
                  </button>
                  <button
                    class="bg-green-dark text-white py-1 px-4 rounded"
                    @click="handleBannerImageUpdate"
                  >
                    Save
                  </button>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </section>
      <div class="grid md:hidden">
        <h3 class="mb-2 font-semibold md:text-2xl text-lg">About</h3>
      </div>
      <div class="md:flex">
        <div class="md:w-8/12 md:py-8 py-2">
            <section>
              <div class="shadow p-3 rounded-lg ring-1 ring-gray-300">
                <h3 class="font-bold mb-5">Completed</h3>
                <div class="flex text-center justify-around items-center">
                  <div class="flex flex-col justify-center items-center">
                    <img
                      class="w-14 rounded-full"
                      :src="require(`@/assets/img/sessions.svg`)"
                      alt="session"
                    />
                    <p class="px-6">
                      Classes
                      <br />
                      <span>{{ completed && completed.session_count }}</span>
                    </p>
                  </div>
                  <div class="flex flex-col justify-center items-center">
                    <img
                      class="w-14 rounded-full"
                      :src="require(`@/assets/img/courses.svg`)"
                      alt="session"
                    />
                    <p class="px-6">
                      Class Packs
                      <br />
                      <span>{{ completed && completed.course_count }}</span>
                    </p>
                  </div>
                  <div class="flex flex-col justify-center items-center">
                    <img
                      class="w-14 rounded-full"
                      :src="require(`@/assets/img/private.svg`)"
                      alt="session"
                    />
                    <p class="px-6">
                      Private
                      <br />
                      <span>
                        {{
                          completed &&
                          completed.private + completed &&
                          completed.course_count
                        }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <div class="xl:flex mt-4 rounded-lg bg-white">
              <section class="p-3 pr-0 pl-0 ring-1 ring-gray-300 rounded-md">
                <div class="p-3 xl:w-40 w-full h-32 text-center">
                  <h3 class="font-bold">Overall Rating</h3>
                  <p class="font-bold-md text-3xl">
                    {{ reviews && reviews.average_rating }}
                  </p>
                  <div class="flex justify-center items-center">
                    <Rating :data="reviews && reviews.average_rating" />
                  </div>
                  <p>{{ reviews && reviews.total_count }} Reviews</p>
                </div>
              </section>
              <section class="p-3 pl-0 w-full ring-1 ring-gray-300 rounded-md">
                <div
                  class="p-3 w-full overflow-y-auto"
                  :class="showDescritionModal === true ? 'h-32' : ''"
                >
                  <h3 class="text-gray-dark font-bold text-md">
                    About the trainer
                  </h3>
                  <p
                    class="text-gray-700 text-sm"
                    v-if="profile && profile.description"
                  >
                    {{
                      showDescritionModal
                        ? profile && profile.description
                        : handleStr(profile && profile.description, 250)
                    }}
                  </p>
                  <p class="text-gray-700 text-sm" v-else>
                    Please add your description
                  </p>
                  <!-- <p
                    v-if="
                      profile &&
                      profile.description &&
                      profile.description.length > 150
                    "
                    class="text-green-light cursor-pointer"
                    @click="showDescritionModal = true"
                  >
                    Read More
                  </p> -->
                  <button
                    type="button"
                    class="text-green-light cursor-pointer focus:outline-none"
                    @click="showDescritionModal = !showDescritionModal"
                    v-if="
                      profile &&
                      profile.description &&
                      profile.description.length > 150
                    "
                  >
                    Read {{ showDescritionModal ? "less" : "more" }}
                  </button>
                </div>
              </section>
            </div>
        </div>
        <section class="md:py-4 md:px-6 px-0">
          <div class="py-6 md:h-32">
            <h3 class="font-bold mb-4">Languages</h3>
            <div
              class="grid gap-4 grid-cols-2"
              v-if="profile && profile.language_names"
            >
              <span
                class="text-gray-800 text-sm ml-1 capitalize flex items-center"
                v-for="d in profile.language_names.split(',')"
                :key="d.id"
              >
                <GlobeAlt />&nbsp;{{ d }}
              </span>
            </div>
          </div>

          <div class="md:pt-4 pt-2 pb-4 md:mt-4">
            <h3 class="font-bold mb-4">Categories</h3>
            <div class="flex" v-if="profile && profile.category_name">
              <div class="grid gap-2 grid-cols-2">
                <span
                  class="h-8 px-4 text-pink-100 transition-colors duration-150 bg-pink-500 rounded-full focus:shadow-outline hover:bg-pink-600 py-1"
                  v-for="d in profile.category_name.split(',')"
                  :key="d.id"
                >
                  {{ d }}
                </span>
              </div>
            </div>
          </div>

          <div class="md:pt-4 pt-2 pb-4 md:mt-4">
            <h3 class="font-bold mb-2">Private Class</h3>
            <p class="text-gray-700 text-sm">
              Class cost around ${{ profile && profile.private_cost }} per hour
            </p>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import Navigation from "@/components/cropper/Navigation";
import { GlobeAlt } from "@/components/icons";
import { Modal, Rating } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";
import { Pencil, Trash } from "@/components/icons";

export default {
  name: "TrainerProfileAbout",
  components: {
    GlobeAlt,
    Modal,
    Rating,
    Pencil,
    Trash,
    Navigation,
    Cropper,
  },
  props: {
    profile: {
      type: Object,
    },
    reviews: {
      type: Object,
    },
    completed: {
      type: Object,
    },
    callerComp: {
      type: String
    }
  },
  data() {
    return {
      thumbnailImage: "",
      thumbnailImagePreview: "",
      isBannerModalOpen: false,
      zoom: 0,
      isBannerOptionsOpen: false,
      showDescritionModal: false,
      details: JSON.parse(localStorage.getItem("details")),
    };
  },
  computed: {
    ...mapGetters(["trainerProfile"]),
    isAdminView () {
      return this.callerComp && this.callerComp.length && this.callerComp === 'adminProfileViewer'
    }
  },
  methods: {
    ...mapActions([
      "getTrainerProfile",
      "trainerProfileBannerUpdate",
      "trainerProfileBannerRemove",
    ]),

    async handleBannerImageUpdate() {
      let data = new FormData();
      data.append("banner_image", this.thumbnailImage);
      await this.trainerProfileBannerUpdate(data);
      await this.getTrainerProfile();
      this.isBannerModalOpen = !this.isBannerModalOpen;
    },

    blobToFile(blob) {
      return new File([blob], `my_image${new Date()}.jpeg`);
    },

    // cropper change
    onChange() {
      const cropper = this.$refs.cropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          this.zoom =
            (cropper.imageSize.height - cropper.coordinates.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
        } else {
          this.zoom =
            (cropper.imageSize.width - cropper.coordinates.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
        }
      }
      const { canvas } = cropper.getResult();
      if (canvas) {
        canvas.toBlob((blob) => {
          this.thumbnailImage = this.blobToFile(blob);
        }, "image/jpeg");
      } else {
        console.log("canvas is not defined");
      }
    },

    // cropper stencil-size
    stencilSize({ boundaries }) {
      return {
        width: Math.min(boundaries.height, boundaries.width) - 48,
        height: Math.min(boundaries.height, boundaries.width) - 48,
      };
    },

    // cropper default-size
    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    // navigation change
    onZoom(value) {
      const cropper = this.$refs.cropper;
      const minWidth = cropper.sizeRestrictions.minWidth;
      const minHeight = cropper.sizeRestrictions.minHeight;

      if (cropper) {
        if (cropper.imageSize.height > cropper.imageSize.width) {
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.width + minWidth) /
              ((1 - value) * cropper.imageSize.width + minWidth)
          );
        } else {
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.height + minHeight) /
              ((1 - value) * cropper.imageSize.height + minHeight)
          );
        }
      }
    },

    handleBannerImageChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }
      this.thumbnailImage = files[0];
      this.createThumbnailImage(this.thumbnailImage);
    },

    createThumbnailImage(file) {
      var reader = new FileReader();

      reader.onload = (e) => {
        this.thumbnailImagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    handleProfileBannerRemove() {
      var c = confirm("Are you sure want to remove?");
      if (c) {
        this.trainerProfileBannerRemove().then(() => {
          this.profile && this.profile.banner_url ? this.profile.banner_url = '' : ''
          this.thumbnailImagePreview = ''
        });
      }
    },
    //Method to Zoom in with buttons with navigation event coming from child(Navigation)
    zoomIn(value) {
      value += 0.011;

      this.onZoom(value);
    },
    //Method to Zoom out with buttons with navigation event coming from child(Navigation)
    zoomOut(value) {
      value -= 0.011;

      this.onZoom(value);
    },
    propfileBannerUploadToggler () {
      this.isBannerModalOpen = !this.isBannerModalOpen;
      this.thumbnailImagePreview = ''
    },
  },
};
</script>